module.exports = __webpack_public_path__ + "assets/img/meeting-2026.ec6c2c03.jpg";